import React from 'react';
import { Autocomplete, styled, TextField } from '@mui/material';
import { Colors } from '../../theme/Colors';
import States from 'constants/States';

const US_STATES = Object.values(States);

interface StateDropdownProps {
    id?: string;
    placeholder?: string;
    value: string | null;
    onChange: (value: string | null) => void;
}

export default function StateDropdown({
    id = 'state',
    placeholder = 'Search for a state...',
    value,
    onChange,
}: StateDropdownProps) {
    return (
        <Autocomplete
            id={id}
            options={US_STATES}
            value={value}
            onChange={(_event, newValue) => onChange(newValue)}
            renderOption={(props, option) => (
                <li {...props}>
                    <StyledOption>{option}</StyledOption>
                </li>
            )}
            renderInput={(params) => (
                <StyledTextField
                    {...params}
                    placeholder={placeholder}
                    variant="outlined"
                    size="small"
                    inputProps={{ ...params.inputProps, id: `${id}-input` }}
                />
            )}
            autoHighlight
            openOnFocus
        />
    );
}

const StyledOption = styled('span')({
    fontFamily: 'Outfit',
    fontSize: 14,
    color: Colors.darkNavy,
});

const StyledTextField = styled(TextField)({
    '& .MuiOutlinedInput-root': {
        fontFamily: 'Outfit',
        borderRadius: 18,
        fontSize: 14,
        color: Colors.darkNavy,
        '& fieldset': {
            borderColor: Colors.mediumNavy,
        },
        '&:hover fieldset': {
            borderColor: Colors.darkNavy,
        },
        '&.Mui-focused fieldset': {
            borderColor: Colors.darkNavy,
        },
    },
    '& .MuiInputBase-input::placeholder': {
        color: Colors.mediumNavy,
        opacity: 1,
    },
    minWidth: 200,
});
